// extracted by mini-css-extract-plugin
export default {"root":"TenantPill_root__zS66z"};